"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProgressiveImg = void 0;
const react_1 = require("react");
const isBlur = (lowQualitySrc, highQualitySrc, currentSrc) => {
    if (lowQualitySrc === highQualitySrc)
        return false;
    return currentSrc === lowQualitySrc;
};
const useProgressiveImg = (lowQualitySrc, highQualitySrc) => {
    const [src, setSrc] = (0, react_1.useState)(lowQualitySrc);
    (0, react_1.useEffect)(() => {
        if (lowQualitySrc === highQualitySrc)
            return;
        setSrc(lowQualitySrc);
        const img = new Image();
        img.src = highQualitySrc;
        img.onload = () => {
            setSrc(highQualitySrc);
        };
        img.onerror = () => {
            setSrc(highQualitySrc);
        };
    }, [lowQualitySrc, highQualitySrc]);
    return [src, { isBlur: isBlur(lowQualitySrc, highQualitySrc, src) }];
};
exports.useProgressiveImg = useProgressiveImg;
//# sourceMappingURL=useProgressiveImg.js.map